<template>
  <div class="examed-list">
    <Header></Header>
    <div class="main">
      <!-- <div class="left-mian">
        <div class="left-item" :class="{act:titleIndex==index}" v-for="(item,index) in titleL" :key="index" @click="titleClick(index)" v-html="item.name" @mousemove="titleActive(index)"></div>
      </div> -->
      <div class="right-mian">
        <div class="item-wrap" v-for="(item,index) in list" :key="index">
          <div class="item">
            <div class="item-left">
              <p style="font-size: 16px;margin-bottom: 10px;"><span>{{ item.ExamPaperName }}</span><span style="color: #c2c2c2;margin-left: 10px;">{{ item.StartTime?item.StartTime.slice(0,10):'1900-01-01' }}</span></p>
              <span style="margin-right: 10px;">得分：<span style="color: #4384f4;">{{ item.TotalScore }}</span></span>
              <span style="margin-right: 10px;">全网排名：<span style="color: #4384f4;">{{ item.RankNo }}</span></span>
              <span style="margin-right: 10px;">地区排名：<span style="color: #4384f4;">{{ item.CityRankNo }}</span></span>
              <span style="margin-right: 10px;">学校排名：<span style="color: #4384f4;">{{ item.SchoolRankNo }}</span></span>
            </div>
            <div class="item-right">
              <el-button type="primary" @click="pathTo(item)">查看成绩</el-button>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import  Header  from '@/components/Header.vue'
export default {
  name: 'ExamedList',
  components:{
    Header
  },
  data() {
    return {
      // titleIndex: 0,
      // titleL: [{ name: '已考列表' }],
      list:[],
    }
  },
  mounted(){
    let parmas = {categoryId:this.$route.query.categoryId}
    this.$api.HJExaminedPaperList(parmas).then(res=>{
      if(res.Success){
        this.list=res.Data
      }else this.$message.error(res.Msg)
    })
  },
  methods:{
    titleActive(index) {
      this.titleIndex = index
    },
    pathTo(item) {
      this.$router.push({
        path: 'CheckExamAnswer',
        query: {
          examID:item.ExamPaperId,
          recordId:item.ExamRecordId,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.examed-list{
  padding-top: 86px;
  height: 100%;
  overflow: hidden;
  .main {
    border-radius: 5px;
    background-color: #fff;
    max-width: 1200px;
    margin: 0 auto;
    height: calc(100% - 10px);
    overflow: hidden;
    // box-shadow: 0px 12px 20px 0px rgba(208, 208, 208, 0.5);
    box-shadow: 0px 12px 20px 0px rgba(193, 193, 193, 0.7);
    display: flex;
    .left-mian {
      width: 150px;
      margin: 10px 0;
      .left-item {
        font-size: 16px;
        padding: 20px 10px 20px 13px;
        display: flex;
        justify-content: flex-end;
        text-align: end;
        > p {
          font-size: 16px;
        }
      }
      .act {
        background-color: #49c1d92e;
        border-right: 2px solid #4384f4;
        font-size: 20px;
      }
    }
    .right-mian {
      height: 100%;
      overflow-y: scroll;
      padding-left: 10px;
      width: calc(100% - 0px);
      box-shadow: -5px 0 10px -5px rgba(208, 208, 208, 0.5);
      .el-divider--horizontal {
        margin: 10px 0;
        background-color: #eeeeeeaf;
      }
      .item {
        padding: 20px 20px 20px 10px;
        display: flex;
        justify-content: space-between;
        .item-left{
          width: 82%;
        }
        .item-right{
          // width: 8%;
        }
      }
    }
  }
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    height: 50px;
    background-color: #b8b8b8;
    -webkit-border-radius: 6px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
    opacity: 0.5;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: #fff;
    -webkit-border-radius: 0;
  }
}

</style>